<template>
  <app-logged id="ClientesCreate">
    <v-flex
      :sm6="!!cliente.id"
      xs12
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            :class-widget="(!!cliente.id) ? 'xs12' : 'md6 offset-md3 sm8 offset-sm2 xs12'"
          >
            <div slot="widget-content">
              <v-checkbox
                v-if="!!cliente.id"
                v-model="cliente.ativo"
                :label="`Cadastro ativo`"
              />
              <validation-provider
                name="nome"
                rules="required|max:255"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="cliente.nome"
                  label="Nome completo"
                  autocomplete="off"
                  outlined
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações de endereço"
                icon="home"
              />
              <validation-provider
                name="endereco"
                rules="required|max:255"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="cliente.endereco"
                  label="Endereço"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="complemento"
                rules="max:300"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="cliente.complemento"
                  label="Complemento"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="cep"
                rules="required|max:9"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="cliente.cep"
                  label="CEP"
                  v-mask="`#####-###`"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="cidade"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  label="Cidade/Estado"
                  :items="cidades"
                  clearable
                  v-model="cliente.cidade_id"
                  :return-object="false"
                  :item-text="cidade"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações pessoais"
                icon="assignment_ind"
              />
              <validation-provider
                name="número do rg"
                rules="max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="cliente.rg_numero"
                  label="RG"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="orgão expedidor"
                rules="max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="cliente.rg_orgao_expedidor"
                  label="Órgão Expedidor"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data da expedição"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="cliente.rg_data_expedicao"
                  label="Data da expedição"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="número do cpf"
                rules="required|max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="cliente.cpf_numero"
                  label="CPF"
                  v-mask="`###.###.###-##`"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data de nascimento"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="cliente.data_nascimento"
                  label="Data de nascimento"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="email"
                rules="email"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="email"
                  v-model="cliente.email"
                  label="E-mail"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações de geolocalização"
                icon="my_location"
              />
              <validation-provider
                name="latitude"
                rules="required|between:-90,90"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="cliente.geo_latitude"
                  label="Latitude"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="longitude"
                rules="required|between:-180,180"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="cliente.geo_longitude"
                  label="Longitude"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações da propriedade"
                icon="terrain"
              />
              <validation-provider
                name="CADPRO"
                rules="required|max:11"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="cliente.cadpro"
                  label="CADPRO"
                  v-mask="`########-##`"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="número da matrícula"
                rules="max:45"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="cliente.numero_matricula"
                  label="Número da matrícula"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="lote"
                rules="max:45"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="cliente.lote"
                  label="Lote"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações sobre o programa Leite Mais"
                icon="today"
              />
              <validation-provider
                name="Data de início no programa leite mais"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="cliente.data_inicio_leite_mais"
                  label="Data de início"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="cliente.id"
                class="mr-2"
                @click.native="remove"
                color="error"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
    <v-flex
      v-if="!!cliente.id"
      sm6
      xs12
    >
      <app-responsaveis-cliente
        class="mb-4"
      />
      <app-lista-telefone
        class="mb-4"
      />
      <app-industrias-cliente />
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppListaTelefone from '@/components/AppListaTelefone'
import AppIndustriasCliente from '@/components/AppIndustriasCliente'
import AppResponsaveisCliente from '@/components/AppResponsaveisCliente'
import AppFormHeader from '@/components/AppFormHeader'
import AppButton from '@/components/AppButton'
export default {
  name: 'ClientesCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppListaTelefone,
    AppIndustriasCliente,
    AppResponsaveisCliente,
    AppButton,
    AppFormHeader
  },
  computed: {
    ...mapGetters(['cidades', 'cliente'])
  },
  watch: {
    'cliente.ativo' (val) {
      if (!val) alert('Ao salvar, todos os vínculos cliente/indústria serão finalizados.')
    }
  },
  methods: {
    ...mapActions(['postSaveCliente', 'deleteCliente']),
    cidade: item => `${item.nome}/${item.acronimo}`,
    goToClienteIndex () {
      this.$router.push({
        name: 'clientes-index'
      })
    },
    remove () {
      if (confirm('Confirme a exclusão deste cliente.')) {
        this.deleteCliente().then(res => {
          this.goToClienteIndex()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveCliente().then(res => {
            this.goToClienteIndex()
          })
        }
      })
    }
  }
}
</script>
